import React from "react";

export const crudContextDefaultValue = {
  searchDefinitions: [],
  handleOpen: (id) => {console.log(id)},
  editableColumns: false,
  editableSearch: false,
  editableTabs: false,
  selectedRows: [],
  clearSelection: () => {},
  handleRefresh: () => {},
  getSearchFormRef: () => null,
  handleDelete: (id) => {console.log(id)},
  search: [],
  modalProps: {},
}

const CrudContext = React.createContext(crudContextDefaultValue)

export default CrudContext
